// extracted by mini-css-extract-plugin
export default {"flex":"ImportWarehouse_flex__WL4UQ","title":"ImportWarehouse_title__XHgLk","input_text":"ImportWarehouse_input_text__7QUM1"};